import type { ReconciliationChallengeAction } from '@shared/api/contracts/reconciliation';
import type { SecondFactor } from '@shared/api/contracts/security';
import type { ReconciliationService } from '@shared/api/lib/reconciliation-service';
import { createIdempotencyKey } from '@entities/withdrawal';

const stripForChallenge = (payload: Record<string, unknown>) =>
  Object.fromEntries(
    Object.entries(payload)
      .filter(([key]) => !['secondFactor', 'code', 'idempotencyKey', 'challengeId'].includes(key))
      .sort(([a], [b]) => a.localeCompare(b)),
  );

export async function runSecureReconciliationCommand<T>(options: {
  reconciliation: ReconciliationService;
  action: ReconciliationChallengeAction;
  targetKey: string;
  businessPayload: Record<string, unknown>;
  reason: string;
  evidenceRefs?: string[];
  secondFactor?: SecondFactor;
  execute: (body: Record<string, unknown>) => Promise<T>;
}): Promise<T> {
  const idempotencyKey = createIdempotencyKey();
  const business = {
    ...options.businessPayload,
    reason: options.reason,
    idempotencyKey,
    ...(options.evidenceRefs?.length ? { evidenceRefs: options.evidenceRefs } : {}),
  };
  const challenge = await options.reconciliation.createChallenge({
    action: options.action,
    targetKey: options.targetKey,
    payload: stripForChallenge(business),
  });
  return options.execute({
    ...business,
    challengeId: challenge.id,
    ...(options.secondFactor ? { secondFactor: options.secondFactor } : {}),
  });
}
